import React, { useEffect, useRef } from 'react';

/* Piezas y estilos compartidos por las pantallas de medicina ocupacional (Fase 2 en adelante). */
export const msg = e => (e && e.response && e.response.data && e.response.data.error) || (e && e.message) || 'Error inesperado';
export const fmtFecha = f => (f ? String(f).slice(0, 10).split('-').reverse().join('/') : '—');
export const fmtFechaHora = f => {
  if (!f) return '—';
  const d = new Date(f);
  if (isNaN(d)) return String(f).slice(0, 16).replace('T', ' ');
  const p = n => String(n).padStart(2, '0');
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
};
export const hoyISO = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; };
export const CARGOS = { MEDICO: 'Médico', ENFERMERA: 'Enfermero/a', PSICOLOGO: 'Psicólogo/a', ODONTOLOGO: 'Odontólogo/a', TRABAJADORA_SOCIAL: 'Trabajador/a social' };
export const TIPOS_EVAL = { INGRESO: 'Ingreso', PERIODICO: 'Periódica', REINTEGRO: 'Reintegro', RETIRO: 'Retiro' };

export const css = `
.mo-kpis{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:16px;}
.mo-kpi{background:var(--surface);border-radius:10px;border:1px solid var(--border);padding:14px 16px;}
.mo-kpi-l{font-size:10.5px;text-transform:uppercase;font-weight:700;color:var(--text3);letter-spacing:.4px;}
.mo-kpi-v{font-size:24px;font-weight:800;color:var(--navy);margin:4px 0 2px;}
.mo-kpi-s{font-size:10.5px;font-weight:700;color:var(--navy);}
.mo-card{background:var(--surface);border-radius:10px;border:1px solid var(--border);overflow:hidden;}
.mo-head{background:#fff;padding:14px 18px;display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap;border-bottom:1px solid var(--border);}
.mo-head-l{display:flex;align-items:center;gap:10px;min-width:0;flex-wrap:wrap;}
.mo-head-r{display:flex;align-items:center;gap:8px;flex-wrap:wrap;}
.mo-title{font-size:13px;font-weight:700;letter-spacing:.5px;text-transform:uppercase;color:var(--navy);}
.mo-title2{font-size:14px;font-weight:700;color:var(--text);}
.mo-sub{font-size:11px;color:var(--text3);margin-top:2px;}
.mo-toolbar{padding:14px 18px;background:#fff;border-bottom:1px solid var(--border);display:flex;align-items:center;gap:10px;flex-wrap:wrap;}
.mo-table thead tr{background:var(--blue-lt);}
.mo-table thead th{padding:13px 16px;font-size:10.5px;font-weight:700;letter-spacing:.5px;text-transform:uppercase;color:var(--navy);border:none;border-bottom:2px solid var(--border);white-space:nowrap;background:var(--blue-lt);}
.mo-table tbody tr:hover{background:var(--blue-lt);}
.mo-table tbody td{padding:12px 16px;font-size:12.5px;border-bottom:1px solid var(--border);color:var(--text2);}
.mo-table tr.click{cursor:pointer;}
.mo-mono{font-family:monospace;font-size:12px;}
.mo-num{text-align:right;font-variant-numeric:tabular-nums;}
.mo-av{width:30px;height:30px;border-radius:50%;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;text-transform:uppercase;}
.mo-foot{padding:14px 18px;background:#fff;border-top:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:8px;}
.mo-foot-i{font-size:11px;color:var(--text3);}
.mo-pag{display:flex;align-items:center;gap:3px;}
.mo-pb{min-width:28px;height:28px;padding:0 6px;border-radius:5px;border:1px solid var(--border);background:#fff;font-size:11px;font-weight:600;color:var(--text2);cursor:pointer;display:flex;align-items:center;justify-content:center;}
.mo-pb:hover:not(:disabled){background:var(--bg);}
.mo-pb.active{background:var(--navy);color:#fff;border-color:var(--navy);}
.mo-pb:disabled{opacity:.35;cursor:default;}
.mo-tabs{display:flex;gap:8px;border-bottom:2px solid var(--border);padding:0 20px;overflow-x:auto;background:#fff;}
.mo-tab{padding:10px 18px;font-size:12px;font-weight:600;color:var(--text3);cursor:pointer;border:0;border-bottom:2px solid transparent;margin-bottom:-2px;background:none;white-space:nowrap;}
.mo-tab.active{color:var(--navy);border-bottom-color:var(--navy);}
.mo-tab:hover:not(.active){color:var(--text);}
.mo-form{display:grid;grid-template-columns:1fr 1fr;gap:14px 20px;padding:20px;}
.mo-form .full{grid-column:1/-1;}
.mo-form .form-group{margin-bottom:0;}
.mo-section{grid-column:1/-1;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.6px;color:var(--text3);padding:6px 0 4px;border-bottom:1px solid var(--bg);margin-top:4px;}
.mo-section:first-child{margin-top:0;}
.mo-alert{margin:14px 20px 0;padding:10px 13px;background:var(--red-lt);color:var(--red);border-radius:8px;font-size:12.5px;}
.mo-ok{margin:14px 20px 0;padding:10px 13px;background:var(--green-lt);color:var(--green);border-radius:8px;font-size:12.5px;}
.mo-warn{margin:14px 20px 0;padding:10px 13px;background:#fff8e6;border:1px solid #f0c36d;color:#7a5b00;border-radius:8px;font-size:12.5px;}
.mo-note{padding:10px 13px;background:var(--blue-lt);color:var(--navy);border-radius:8px;font-size:12px;line-height:1.5;}
.mo-dato{font-size:13px;color:var(--text);padding:2px 0;min-height:18px;}
.mo-mxwrap{overflow:auto;max-height:420px;border:1px solid var(--border);border-radius:8px;}
.mo-mx{width:100%;border-collapse:collapse;}
.mo-mx th,.mo-mx td{padding:5px 8px;font-size:12px;border-bottom:1px solid var(--bg);}
.mo-mx th{color:var(--text3);font-weight:700;text-align:center;background:var(--surface2);position:sticky;top:0;z-index:1;}
.mo-mx td:first-child,.mo-mx th:first-child{text-align:left;position:sticky;left:0;background:#fff;min-width:210px;}
.mo-mx th:first-child{background:var(--surface2);z-index:2;}
.mo-mx td.c{text-align:center;}
.mo-mx tr.cat td{background:var(--blue-lt);font-weight:700;font-size:10.5px;text-transform:uppercase;letter-spacing:.5px;color:var(--navy);}
.mo-chk{display:inline-flex;align-items:center;gap:6px;font-size:12px;color:var(--text2);cursor:pointer;}
.mo-lin{display:flex;gap:8px;align-items:center;flex-wrap:wrap;}
.mo-panel{margin:14px 18px 0;padding:12px 14px;background:var(--amber-lt);border:1px solid #f0c36d;border-radius:8px;display:flex;gap:12px;align-items:center;flex-wrap:wrap;font-size:12.5px;color:#7a5b00;}
@media (max-width:900px){.mo-kpis{grid-template-columns:repeat(2,1fr);}}
@media (max-width:700px){.mo-form{grid-template-columns:1fr;}}
@media (max-width:520px){.mo-kpis{grid-template-columns:1fr;}}
.mo-pasos{display:flex;gap:0;padding:14px 20px;background:#fff;border-bottom:1px solid var(--border);flex-wrap:wrap;gap:8px 22px;}
.mo-paso{display:flex;align-items:center;gap:8px;font-size:12px;font-weight:600;color:var(--text3);}
.mo-paso .n{width:22px;height:22px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;background:var(--bg);color:var(--text3);border:1px solid var(--border);}
.mo-paso.ok{color:var(--green);} .mo-paso.ok .n{background:var(--green);color:#fff;border-color:var(--green);}
.mo-paso.act{color:var(--navy);} .mo-paso.act .n{background:var(--navy);color:#fff;border-color:var(--navy);}
.mo-doc{margin:0 20px;border:1px solid var(--border);border-radius:8px;background:#fff;max-height:340px;overflow:auto;padding:16px 20px;font-size:12.5px;line-height:1.55;color:var(--text);}
.mo-doc h4{margin:0 0 10px;font-size:13px;text-align:center;text-transform:uppercase;color:var(--navy);}
.mo-doc p{margin:0 0 9px;text-align:justify;}
.mo-sig-box{border:1px dashed var(--border);border-radius:8px;background:#fff;display:inline-block;line-height:0;max-width:100%;}
.mo-sig-box canvas{touch-action:none;cursor:crosshair;max-width:100%;height:auto;}
.mo-sig-img{max-height:70px;max-width:240px;border-bottom:1px solid var(--text3);padding:0 8px;}
.mo-cuerpo{padding:16px 20px;}
.mo-cuerpo > * + *{margin-top:14px;}
.mo-hash{font-family:monospace;font-size:10.5px;color:var(--text3);word-break:break-all;}
.mo-sel-lista{border:1px solid var(--border);border-radius:8px;max-height:220px;overflow:auto;background:#fff;}
.mo-sel-lista div{padding:8px 12px;font-size:12.5px;cursor:pointer;border-bottom:1px solid var(--bg);}
.mo-sel-lista div:hover{background:var(--blue-lt);}
.mo-sel-lista div.sel{background:var(--blue-lt);font-weight:700;color:var(--navy);}
`;

export function Cab({ onVolver, titulo, sub, children }) {
  return (
    <div className="mo-head">
      <div className="mo-head-l">
        {onVolver && <button className="btn btn-sm" onClick={onVolver}>← Atrás</button>}
        <div><div className="mo-title2">{titulo}</div>{sub && <div className="mo-sub">{sub}</div>}</div>
      </div>
      <div className="mo-head-r">{children}</div>
    </div>
  );
}

export function Campo({ label, req, full, children }) {
  return (
    <div className={'form-group' + (full ? ' full' : '')}>
      <label className="form-label">{label}{req && <span style={{ color: 'var(--red)' }}> *</span>}</label>
      {children}
    </div>
  );
}

export function Pager({ pag, paginas, total, pagina, setPag }) {
  const desde = total === 0 ? 0 : pag * pagina + 1;
  const hasta = Math.min((pag + 1) * pagina, total);
  const nums = [];
  for (let i = Math.max(0, pag - 2); i <= Math.min(paginas - 1, pag + 2); i++) nums.push(i);
  return (
    <div className="mo-foot">
      <span className="mo-foot-i">{total > 0 ? `Mostrando ${desde} a ${hasta} de ${total.toLocaleString()} registros` : 'Sin registros'}</span>
      <div className="mo-pag">
        <button className="mo-pb" disabled={pag === 0} onClick={() => setPag(0)} title="Primera">⏮</button>
        <button className="mo-pb" disabled={pag === 0} onClick={() => setPag(pag - 1)} title="Anterior">‹</button>
        {nums.map(n => <button key={n} className={'mo-pb' + (n === pag ? ' active' : '')} onClick={() => setPag(n)}>{n + 1}</button>)}
        <button className="mo-pb" disabled={pag + 1 >= paginas} onClick={() => setPag(pag + 1)} title="Siguiente">›</button>
        <button className="mo-pb" disabled={pag + 1 >= paginas} onClick={() => setPag(paginas - 1)} title="Última">⏭</button>
      </div>
    </div>
  );
}

/* Texto legal tal como se firma (viene del servidor, nunca se arma aquí). */
/** Abre el diálogo de impresión con un documento HTML completo (sin ventanas emergentes). «Guardar como PDF» genera el archivo. */
export function imprimirHTML(html, archivo) {
  const f = document.createElement('iframe');
  f.setAttribute('aria-hidden', 'true');
  f.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden';
  const titPrevio = document.title;
  const limpiar = () => { document.title = titPrevio; setTimeout(() => { try { document.body.removeChild(f); } catch (e) { /* ya no está */ } }, 500); };
  f.onload = () => {
    try {
      const w = f.contentWindow;
      document.title = archivo || titPrevio;                          // el navegador usa este nombre al guardar el PDF
      w.addEventListener('afterprint', limpiar);
      w.focus(); w.print();
      setTimeout(() => { if (document.title !== titPrevio && !w.closed) limpiar(); }, 60000);
    } catch (e) { limpiar(); }
  };
  f.srcdoc = html;
  document.body.appendChild(f);
}

/* ── Impresión / PDF de documentos legales ─────────────────────────────────────────
   Abre el diálogo de impresión del navegador con el documento en formato carta/A4 ("Guardar como PDF" genera el archivo).
   opts: { titulo, parrafos[], firma_label, firmante:{nombre, detalle}, firma (PNG/JPG data URL o null),
           pie:[líneas pequeñas: versión, huella, fecha de firma…], archivo (nombre sugerido del PDF) }
   Sin `firma` deja la línea en blanco para firmar a mano. */
export const escH = t => String(t == null ? '' : t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
export function imprimirDocumento(opts) {
  const o = opts || {};
  const img = o.firma && /^data:image\/(png|jpe?g);base64,[A-Za-z0-9+/=]+$/.test(o.firma) ? o.firma : null;
  const enc = p => /^(CLÁUSULA|COMPARECIENTES|\d+\.\s*[A-ZÁÉÍÓÚ]|“?Art\.)/.test(p) && p.length < 120;
  const html = `<!doctype html><html lang="es"><head><meta charset="utf-8"><title>${escH(o.archivo || o.titulo)}</title><style>
@page{size:A4;margin:22mm 20mm}
*{box-sizing:border-box}
body{font-family:'Times New Roman',Georgia,serif;font-size:11.5pt;line-height:1.45;color:#000;margin:0}
h1{font-size:13pt;text-align:center;margin:0 0 14pt;text-transform:uppercase}
p{margin:0 0 8pt;text-align:justify}
p.h{font-weight:bold;margin-top:10pt;text-align:left}
.firma{margin-top:34pt;page-break-inside:avoid}
.firma .lbl{font-weight:bold;margin-bottom:6pt}
.firma .img{height:70pt;display:flex;align-items:flex-end}
.firma img{max-height:70pt;max-width:260pt}
.firma .lin{border-top:1px solid #000;width:260pt;padding-top:4pt;margin-top:2pt}
.firma .det{font-size:10.5pt}
.pie{margin-top:22pt;padding-top:8pt;border-top:1px solid #999;font:8.5pt/1.4 'Courier New',monospace;color:#333;word-break:break-all;page-break-inside:avoid}
</style></head><body>
<h1>${escH(o.titulo)}</h1>
${(o.parrafos || []).map(p => `<p class="${enc(p) ? 'h' : ''}">${escH(p)}</p>`).join('\n')}
<div class="firma">
  <div class="lbl">${escH(o.firma_label || 'FIRMA:')}</div>
  <div class="img">${img ? `<img src="${img}" alt="Firma">` : ''}</div>
  <div class="lin"></div>
  <div class="det"><b>${escH(o.firmante && o.firmante.nombre)}</b>${o.firmante && o.firmante.detalle ? '<br>' + escH(o.firmante.detalle) : ''}</div>
</div>
${(o.pie && o.pie.length) ? `<div class="pie">${o.pie.map(escH).join('<br>')}</div>` : ''}
</body></html>`;
  imprimirHTML(html, o.archivo || o.titulo);
}

/** Pide el texto firmado al servidor (el que se firmó, con su huella) y abre la impresión. `quien` = datos del firmante. */
export async function imprimirConsentimiento(api, cod, { firmante, firma_label, archivo }) {
  const { data: c } = await api.get(`/ocupacional/consentimientos/${cod}`);
  const partes = String(c.TEXTO_FIRMADO || '').split('\n\n');
  const titulo = partes.shift();
  const medio = c.MEDIO === 'PAPEL' ? 'firmado en papel (registrado en el sistema)' : 'firma digital';
  imprimirDocumento({
    titulo, parrafos: partes, firma_label, firmante,
    firma: c.MEDIO === 'DIGITAL' ? c.FIRMA : null, archivo,
    pie: [`${c.VERSION_TEXTO} · ${medio} el ${fmtFechaHora(c.FECHA_FIRMA)}`, `Huella SHA-256 del texto: ${c.HASH_TEXTO}`].concat(c.ESTADO === 'ANULADO' ? ['DOCUMENTO ANULADO el ' + fmtFechaHora(c.FECHA_ANULACION) + ': ' + (c.MOTIVO_ANULACION || '')] : []),
  });
}

export function DocumentoLegal({ documento }) {
  if (!documento) return null;
  return (
    <div className="mo-doc" tabIndex={0}>
      <h4>{documento.titulo}</h4>
      {documento.parrafos.map((p, i) => <p key={i}>{p}</p>)}
    </div>
  );
}

/* Recuadro para firmar con el dedo, lápiz o mouse. onChange recibe un PNG (data URL) o null si está vacío. */
export function FirmaPad({ onChange, ancho = 400, alto = 160 }) {
  const ref = useRef(null);
  const dibujando = useRef(false);
  const hayTrazo = useRef(false);

  const ctx = () => { try { return ref.current && ref.current.getContext && ref.current.getContext('2d'); } catch { return null; } };
  useEffect(() => {
    const c = ctx();
    if (!c) return;
    c.lineWidth = 2.2; c.lineCap = 'round'; c.lineJoin = 'round'; c.strokeStyle = '#14213d';
  }, []);

  const pos = e => {
    const r = ref.current.getBoundingClientRect();
    return { x: (e.clientX - r.left) * (ancho / (r.width || ancho)), y: (e.clientY - r.top) * (alto / (r.height || alto)) };
  };
  const ini = e => {
    const c = ctx(); if (!c) return;
    e.preventDefault();
    try { ref.current.setPointerCapture(e.pointerId); } catch {}
    dibujando.current = true;
    const { x, y } = pos(e);
    c.beginPath(); c.moveTo(x, y); c.lineTo(x + 0.1, y + 0.1); c.stroke();
    hayTrazo.current = true;
  };
  const mov = e => {
    if (!dibujando.current) return;
    const c = ctx(); if (!c) return;
    e.preventDefault();
    const { x, y } = pos(e);
    c.lineTo(x, y); c.stroke();
  };
  const fin = () => {
    if (!dibujando.current) return;
    dibujando.current = false;
    try { onChange(hayTrazo.current ? ref.current.toDataURL('image/png') : null); } catch { onChange(null); }
  };
  const limpiar = () => {
    const c = ctx();
    if (c) c.clearRect(0, 0, ancho, alto);
    hayTrazo.current = false;
    onChange(null);
  };

  return (
    <div>
      <div className="mo-sig-box">
        <canvas ref={ref} width={ancho} height={alto} style={{ width: ancho }}
          onPointerDown={ini} onPointerMove={mov} onPointerUp={fin} onPointerLeave={fin} onPointerCancel={fin} />
      </div>
      <div className="mo-lin" style={{ marginTop: 8 }}>
        <button type="button" className="btn btn-sm" onClick={limpiar}>Borrar y volver a firmar</button>
        <span className="mo-sub">Firme dentro del recuadro.</span>
      </div>
    </div>
  );
}
